import React from 'react';
import { Theme, withStyles } from '@material-ui/core';
import CardLayout, { getCardLayoutStyles } from '../CardLayout';
import PickupReviewBody from './PickupReviewBody';
import { formatMoreToReviewFooter } from './formatMoreToReviewFooter';
import { PICKUP_REVIEW_CONTENT } from '../../content';
import type { CardProps, NotificationHandlers, ToBeReviewedItem } from '../../types';
import { getPickupStatusTypeIcon } from '../../../../../modules/Dispatch/RouteExecution/utils/pickupStatusTypeIcon';
import { PICKUP_STATUS } from '../../../../../modules/Dispatch/RouteExecution/constants';

type RouteMaxTheme = Theme & {
  actionableTextColor?: string;
  palette: Theme['palette'];
};

type PickupReviewProps = CardProps<ToBeReviewedItem> & {
  classes: Record<string, string>;
  theme: Theme;
  handlers: NotificationHandlers;
};

/**
 * Same summary card for All and Pickups chips: title + driver/shipper.
 * Footer "+n pickups to be reviewed" when aggregation sets moreToReviewCount.
 */
const PickupReview = ({ classes, theme, item, handlers }: PickupReviewProps) => {
  const moreToReview = formatMoreToReviewFooter(item.moreToReviewCount);

  const handleClick = () => {
    handlers.onPickupReviewClick(item);
  };

  return (
    <CardLayout
      classes={classes}
      icon={getPickupStatusTypeIcon({
        status: PICKUP_STATUS.toBeReviewed,
        theme,
        size: 34,
        isActive: false,
        badgeContent: undefined,
      })}
      title={PICKUP_REVIEW_CONTENT.summaryTitle}
      body={<PickupReviewBody item={item} />}
      footer={
        moreToReview ? (
          <span className={classes.moreToReviewFooter}>{moreToReview}</span>
        ) : undefined
      }
      timestamp={item.timestamp}
      onClick={handleClick}
    />
  );
};

const styles = (theme: Theme) => {
  const routeMaxTheme = theme as RouteMaxTheme;
  const cardStyles = getCardLayoutStyles(theme);

  return {
    ...cardStyles,
    moreToReviewFooter: {
      color: routeMaxTheme.actionableTextColor || routeMaxTheme.palette.primary.main,
      fontWeight: 500,
      lineHeight: '16px',
    },
  };
};

export default withStyles(styles as Parameters<typeof withStyles>[0], { withTheme: true })(
  PickupReview
);
